export default {
  "该页面暂无权限访问": "该页面暂无权限访问",
  "请填写号码": "请填写号码",
  "区号": "区号",
  "全部": "全部",
  "上传图片": "上传图片",
  "未找到该页面": "未找到该页面",
  "选择区号": "选择区号"
}
